import _BaseApiService from "../_BaseAPIService"

const apiService= _BaseApiService.instance;

const StudentService = {
    create: async(data) => {
        const response = await apiService.post("/studentinterestforms",data);
        return response.data; 
    },
    getList:async()=>{
        const response = await apiService.get("/studentinterestforms");
        return response.data;

    },
    getDetail:async(id) => {
        const response = await apiService.get(`/studentinterestforms/${id}`);
        return response.data;
    },
};
export default StudentService;